import React, { useEffect, useRef, useState } from "react";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import DatePicker from "../../components/range-date-picker/RangeDatePicker";

import ReactToPrint from "react-to-print";
import { getToken } from "../../helper/auth";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, } from 'recoil';
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { popupCustomerFlowAtom, popupTransactionHistoryAtom } from '../../state';
import { CURRENCY_CODE } from "../../utils/Utils";


const ReportAllBankAccounts = () => {
  const printRef = useRef();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [popupTransactionHistory] = useRecoilState(popupTransactionHistoryAtom);
  const [popupCustomerFlow] = useRecoilState(popupCustomerFlowAtom);
  const history = useHistory();
  const clearPagi = useRef();
  const [data, setData] = useState([]);


  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState(moment().valueOf());
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [updatedAt, setUpdatedAt] = useState(moment().valueOf());
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get('start') ? moment(searchParams.get('start')).startOf('days').toDate() : moment().startOf("months").toDate(),
    end: searchParams.get('end') ? moment(searchParams.get('end')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const colTable = [
    {
      Header: "STT",
      accessor: (item, i) => i + 1,
    },
    {
      Header: "Tên quỹ tài khoản",
      accessor: (item) => item?.name || "",
    },

    {
      Header: "Tồn đầu kì(đ)",
      className: 'text-right',
      accessor: (item) =>
        <NumericFormat
          displayType={"text"}
          value={item.firstAmount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
    },
    {
      Header: "Thu(đ)",
      className: 'text-right',
      accessor: (item) =>
        <NumericFormat
          displayType={"text"}
          value={item.inAmount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
    },
    {
      Header: "Chi(đ)",
      className: 'text-right',
      accessor: (item) =>
        <NumericFormat
          displayType={"text"}
          value={item.outAmount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
    },
    {
      Header: "Tồn cuối kỳ(đ)",
      className: 'text-right',
      accessor: (item) =>
        <NumericFormat
          displayType={"text"}
          value={item.lastAmount || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
    },
    {
      Header: "Tồn đầu kì($)",
      className: 'text-right',
      accessor: (item) =>
        item.currencyCode === CURRENCY_CODE.USD ?
          <NumericFormat
            displayType={"text"}
            value={item.firstAmountUSD || 0}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            decimalScale={2}
          />
          : ''
    },
    {
      Header: "Thu($)",
      className: 'text-right',
      accessor: (item) => item.currencyCode === CURRENCY_CODE.USD ?
        <NumericFormat
          displayType={"text"}
          value={item.inAmountUSD || 0}
          thousandsGroupStyle="thousand"
          thousandSeparator=","
          decimalScale={2}
        />
        : ''
    },
    {
      Header: "Chi($)",
      className: 'text-right',
      accessor: (item) =>
        item.currencyCode === CURRENCY_CODE.USD ?
          <NumericFormat
            displayType={"text"}
            value={item.outAmountUSD || 0}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            decimalScale={2}
          />
          : ''
    },
    {
      Header: "Tồn cuối kỳ($)",
      className: 'text-right',
      accessor: (item) =>
        item.currencyCode === CURRENCY_CODE.USD ?
          <NumericFormat
            displayType={"text"}
            value={item.lastAmountUSD || 0}
            thousandsGroupStyle="thousand"
            thousandSeparator=","
            decimalScale={2}
          />
          : ''
    },
    {
      Header: "Ghi chú",
      accessor: () => ''
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      start: moment(rangeDate.start).format("YYYY-MM-DD"),
      end: moment(rangeDate.end).format("YYYY-MM-DD"),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/transaction-history/report-by-find-all-by-bank-accounts-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    setLoading(true);
    setData([]);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {

        start: moment(rangeDate.start).format('YYYY-MM-DD'),
        end: moment(rangeDate.end).format('YYYY-MM-DD'),
      };

      GET(`transaction-history/find-all-by-bank-accounts`, params, true)
        .then(({ data }) => {
          setData([...data?.rows].filter(e => e.firstAmount !== 0 || e.lastAmount !== 0 || e.inAmount !== 0 || e.outAmount !== 0));
          setSummary({
            ...data.summary,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [timeNow, updatedAt, popupTransactionHistory.updatedAt, popupCustomerFlow.updatedAt]);


  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              {/* <BlockTitle page>
                Báo cáo
              </BlockTitle> */}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          dateFormat={'dd/MM/yy'}
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>

                    </li>




                    <li>
                      <div className="form-control-wrap">
                        <ReactToPrint
                          trigger={() => <Button className={'btn btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                        />
                        <Button onClick={exportExcel} className="btn btn-secondary ml-3">
                          Xuất excel
                        </Button>
                      </div>
                    </li>


                    <li>

                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                          {/* <label>
                            <span className="d-none d-sm-inline-block">Show</span>
                            <Input type="month" />
                          </label> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">BÁO CÁO TỔNG HỢP SỔ QUỸ</h5>
                  <h6 className="text-center">Từ ngày {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')}</h6>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    onRowDoubleClick={(item) => {
                      const newParams = new URLSearchParams({
                        ...rangeDate,
                      });
                      history.push({
                        pathname: `/bank-account/money/${item.id}`,
                        search: newParams.toString(),
                      })
                    }}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td ></td>
                      <td ></td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.firstAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.inAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.outAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.lastAmount}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>


                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.firstAmountUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.inAmountUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.outAmountUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col  text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.lastAmountUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>

                      <td></td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default ReportAllBankAccounts;
